import React, { useState } from 'react'
import { useSelector } from 'react-redux'

export default function Enquire(){
  const { trips, whatsapp, formspreeId } = useSelector(s => s.app)
  const [status, setStatus] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus(null)
    const form = e.target
    const name = form.name.value.trim()
    const email = form._replyto.value.trim()
    const message = form.message.value.trim()
    if(!name || !email || !message){ setStatus({type:'error', msg:'Please fill all fields.'}); return }
    const action = form.getAttribute('action')
    if(action && action.indexOf('yourFormId') !== -1){ setStatus({type:'info', msg:'Replace the Formspree ID in the form action to enable submissions.'}); form.reset(); return }
    try{
      const resp = await fetch(action, { method:'POST', body: new FormData(form), headers: {'Accept':'application/json'} })
      if(resp.ok){ setStatus({type:'success', msg:'Thanks — your message was sent.'}); form.reset() }
      else { const data = await resp.json(); setStatus({type:'error', msg: data.error || 'Submission failed'}) }
    }catch(err){ setStatus({type:'error', msg: err.message}) }
  }

  return (
    <main className="container">
      <h1>Enquire</h1>
      <p className="lead">Choose a trip plan below and contact us on WhatsApp to book or ask questions.</p>

      <section className="plans grid">
        {trips.map(t => (
          <article className="card" key={t.id}>
            <h3>{t.title}</h3>
            <p>{t.desc} Price: From {t.price}</p>
            <a className="btn whatsapp colorWhite" href={`https://wa.me/${whatsapp}?text=${encodeURIComponent('I am interested in ' + t.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
          </article>
        ))}
      </section>

      <section className="contact card">
        <h2>Contact Us</h2>
        <p>Send us a quick message and we'll get back to you.</p>
        <form action={`https://formspree.io/f/${formspreeId || 'yourFormId'}`} method="POST" className="contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">Name</label>
          <input id="name" name="name" type="text" required />

          <label htmlFor="email">Email</label>
          <input id="email" name="_replyto" type="email" required />

          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" rows="4" required></textarea>

          <input type="hidden" name="_subject" value="New enquiry from Travel Trip Journey" />
          <button className="btn" type="submit">Send Message</button>
        </form>
        {status && (
          <div className={`form-feedback ${status.type === 'success' ? 'success' : (status.type === 'error' ? 'error' : '')}`}>
            {status.msg}
          </div>
        )}
        <p className="muted">WhatsApp number: <strong>{whatsapp}</strong></p>
      </section>
    </main>
  )
}
